import React from 'react'
import {Container, ContainerOwnProps} from '@mui/material'
import {styled} from "@mui/styles";

const Root = styled(Container)(() => ({
  padding: '1.3rem',
}));

/**
 * General-purpose page-level layout wrapper built on MUI `Container`.
 *
 * Centers content horizontally, caps width at the `lg` breakpoint, and applies
 * uniform padding (`1.3rem`) on all sides. Use this as the outermost shell for
 * standard pages that do **not** need responsive report-style insets.
 *
 * @example
 * // Simple page wrapper
 * <SecurSpaceContainer>
 *   <MyPageContent />
 * </SecurSpaceContainer>
 *
 * @example
 * // Wrap a report page layout component to apply consistent page-level padding and centering
 * <SecurSpaceContainer>
 *   <SecurSpaceReportContainer>
 *     <MyReportContent />
 *   </SecurSpaceReportContainer>
 * </SecurSpaceContainer>
 *
 * @see SecurSpaceReportContainer for a more opinionated layout wrapper with responsive padding and grid-based layout, ideal for report pages and tabbed views.
 */
const SecurSpaceContainer = (props: ContainerOwnProps) => {
  return (
    <Root maxWidth="lg" disableGutters={true} {...props} />
  )
}

export default SecurSpaceContainer;
